/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ArrowRight12(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ArrowRight12',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","fillRule":"evenodd","d":"M8.19 5.008 4.947 1.765 6.362.35l5.656 5.658-5.656 5.657-1.415-1.415L8.19 7.008H-.002v-2z"}))
}
